import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.917 10.965a1.75 1.75 0 0 1-.671-3.366 1.167 1.167 0 0 0-1.08-.717H5.834a2.28 2.28 0 0 1-1.166-.327v3.348a1.75 1.75 0 1 1-1.167 0V5.027a1.75 1.75 0 1 1 1.26-.03 1.167 1.167 0 0 0 1.073.718h2.334a2.333 2.333 0 0 1 2.28 1.843 1.75 1.75 0 0 1-.53 3.407Zm-5.834 1.167a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Zm0-9.334a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167Zm5.834 5.834a.583.583 0 1 0 0 1.166.583.583 0 0 0 0-1.166Z" }, null, -1)
  ])))
}
export default { render: render }